import { all, call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import {
  authenticate,
  deAuthenticate,
  setAuthenticationStatus,
  setMfaChallenge,
} from "../../reducers/authSlice";
import { getUser, setUser } from "../../reducers/userSlice";
import { authApi } from "../apis/authApi";
import { returnErrors } from "../../reducers/error";

function* authUser({ payload }) {
  try {
    const response = yield call(authApi, payload);
    const data = response?.data?.data || response?.data || {};

    const challenge =
      data.mfa_setup_challenge ||
      data.mfa_challenge ||
      data.challenge ||
      data.temp_token ||
      data.mfa_token ||
      data.token ||
      data.sessionToken;

    const isMfaSetup = Boolean(
      data.mfa_setup_required ||
      data.requires_setup ||
      data.is_mfa_setup_required ||
      data.mfa_setup_challenge,
    );

    const isMfaLogin = Boolean(
      data.mfa_required ||
      data.requires_mfa ||
      data.mfa_needed ||
      data.requires_2fa ||
      data.is_mfa_required ||
      (challenge && !data.idToken),
    );

    // Check if response indicates MFA Setup or MFA Verification is required
    if (isMfaSetup || isMfaLogin) {
      if (challenge) {
        try {
          sessionStorage.setItem("ee_mfa_challenge", challenge);
          if (data.mfa_setup_challenge) {
            sessionStorage.setItem(
              "ee_mfa_setup_challenge",
              data.mfa_setup_challenge,
            );
          }
        } catch (e) {}
      }
      if (payload?.password) {
        try {
          sessionStorage.setItem("ee_login_password", payload.password);
        } catch (e) {}
      }
      if (payload?.email) {
        try {
          localStorage.setItem("ee_login_email", payload.email);
        } catch (e) {}
      }
      yield put(
        setMfaChallenge({
          ...data,
          mfa_setup_required: isMfaSetup,
          mfa_setup_challenge: data.mfa_setup_challenge || challenge,
          mfa_challenge: challenge,
          challenge: challenge,
          email: payload?.email,
          password: payload?.password,
        }),
      );
      return;
    }

    if (response?.status >= 200 && response?.status < 300) {
      if (response.data && response.data.sessionToken) {
        localStorage.setItem("ee-session-token", response.data.sessionToken);
        axios.defaults.headers.common["X-SESSION-TOKEN"] =
          response.data.sessionToken;
      }
      yield put(setAuthenticationStatus(response));
      if (
        response.data?.idToken &&
        typeof response.data.idToken === "string" &&
        response.data.idToken.split(".").length === 3
      ) {
        yield put(getUser(response.data.idToken));
      }
    } else {
      yield put(setAuthenticationStatus(false));
      let msg = "Invalid email or password";
      if (data?.detail) {
        msg =
          typeof data.detail === "object"
            ? Object.values(data.detail)[0]
            : data.detail;
        if (Array.isArray(msg)) msg = msg[0];
      } else if (typeof data === "object" && Object.keys(data).length > 0) {
        const firstKey = Object.keys(data)[0];
        msg = data[firstKey];
        if (Array.isArray(msg)) msg = msg[0];
      }
      yield put(returnErrors(msg, 400));
    }
  } catch (error) {
    yield put(setAuthenticationStatus(false));
    yield put(returnErrors("Authentication failed", 400));
  }
}

function* deAuthUser() {
  yield put(setUser(null));
}

export default function* authSaga() {
  yield all([
    takeEvery(authenticate.type, authUser),
    takeEvery(deAuthenticate.type, deAuthUser),
  ]);
}
